import { post } from '../utils/http';
import { APIResponse } from '../types/api-response';
import { GenerateVerificationCodeResponse } from './register';

export async function session(token: string): Promise<APIResponse> {
  return await post('1.0/auth/session', { token });
}

export interface LoginResponse {
  token: string;
  uid: string;
  sysadmin: boolean;
  newUser: boolean;
}

export async function login(email: string, password: string): Promise<APIResponse<LoginResponse>> {
  return await post('1.0/auth/login', { email, password });
}

export async function logout(token: string): Promise<APIResponse> {
  return await post('1.0/auth/logout', { token });
}

export interface LoginOrganisationResponse {
  sut: string;
  tenant_id: string;
}

export async function loginOrganisation(token: string, tenantId: string): 
  Promise<APIResponse<LoginOrganisationResponse>> {
  return await post('1.0/auth/loginOrganisation', { token, tenant_id: tenantId });
}

export async function forgotPassword(email: string): 
  Promise<APIResponse<GenerateVerificationCodeResponse>> {
  return post('1.0/auth/forgotpassword', { email });
}

export async function changePassword(email: string, token: string, newPassword: string, code?: string): 
  Promise<APIResponse> {
  if (code) {
    return post('1.0/auth/changepasswordbyemailverification', { email, token, code, newPassword });
  }
  return post('1.0/auth/changepassword', { email, token, newPassword });
}